export default __webpack_public_path__ + "img/jtc/jtc2_480.webp";